import PropTypes from 'prop-types';

export const MetadataPropType = PropTypes.shape({
    type: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
    customizationType: PropTypes.string,
});

export const CUSTOMIZATION_TYPE = {
    EXIT_MESSAGE: 'EXIT_MESSAGE',
    BROWSER_BAR: 'BROWSER_BAR',
    CONTENT_FILTERING: 'CONTENT_FILTERING',
    MALICIOUS_THREAT: 'MALICIOUS_THREAT',
    REGISTRATION_NOTICE: 'REGISTRATION_NOTICE',
};
